import { Theme, withStyles } from '@material-ui/core'
import { FC, useCallback, useState } from 'react'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { WrappedFieldProps } from 'redux-form'
import { MuiClasses } from '../../../types'

const styles = ({ breakpoints }: Theme) => ({
  error: {
    position: 'absolute' as const,
    top: '6px',
    right: '10px',
    display: 'block',
    fontSize: '11px',
    color: 'red',
    margin: '0',
    marginTop: '0',
    textAlign: 'left' as const,
    fontFamily: 'CircularRegular',
    'font-weight': '400',
    lineHeight: '1.66',
    letterSpacing: '0.03333em'
  },
  placeholder: {
    position: 'absolute' as const,
    left: '80px',
    bottom: '9px',
    zIndex: 1,
    fontFamily: 'CircularRegular',
    fontSize: '13px',
    color: 'rgb(155, 155, 155)'
  }
})
interface OwnProps {
  label: string
  isError: boolean
  placeholder: any
  classes: MuiClasses
}

const ReduxPhoneField: FC<WrappedFieldProps & OwnProps> = ({
  classes,
  input,
  meta: { touched, error, submitFailed },
  label,
  isError,
  placeholder
}) => {
  const handleOnChange = useCallback(
    (value, country) => {
      const dialCode: string = country?.dialCode || ''
      // "358 0401234567" → "358401234567": drop the national trunk zero instead of rejecting it
      const phone =
        dialCode && value.startsWith(`${dialCode}0`)
          ? `${dialCode}${value.slice(dialCode.length + 1)}`
          : value
      input.onChange({
        phone,
        countryDialCode: dialCode
      })
    },
    [input]
  )
  // Ensure value shape without mutating props directly
  // If an upstream passes a raw string value, normalize it once via onChange
  if (typeof input.value === 'string') {
    input.onChange({ phone: input.value })
  }
  const [isShown, setIsShown] = useState(true)
  const handleOnBlur = useCallback(() => {
    input.onBlur(input.value)
    setIsShown(true)
  }, [input])
  return (
    <div style={{ position: 'relative', height: '32px' }}>
      {isShown && input.value.phone?.length <= 3 ? (
        <div className={classes.placeholder}>{placeholder}</div>
      ) : null}
      <PhoneInput
        specialLabel={label}
        country='fi'
        value={input.value.phone}
        onChange={handleOnChange}
        placeholder={placeholder}
        onFocus={() => setIsShown(false)}
        onBlur={handleOnBlur}
        autoFormat={false}
        countryCodeEditable={false}
        inputProps={{ name: 'phone', autoComplete: 'tel', inputMode: 'tel' }}
      />
      {isError && (touched || submitFailed) && error !== undefined && (
        <p className={classes.error}>{error}</p>
      )}
    </div>
  )
}

export default withStyles(styles)(ReduxPhoneField)
